/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const BankAccountStatus = {
  New: "new",
  Verified: "verified",
  VerificationFailed: "verificationFailed",
  Pending: "pending",
  Errored: "errored",
} as const;
export type BankAccountStatus = ClosedEnum<typeof BankAccountStatus>;

/** @internal */
export const BankAccountStatus$inboundSchema: z.ZodNativeEnum<
  typeof BankAccountStatus
> = z.nativeEnum(BankAccountStatus);
/** @internal */
export const BankAccountStatus$outboundSchema: z.ZodNativeEnum<
  typeof BankAccountStatus
> = BankAccountStatus$inboundSchema;
